import React, { FC } from 'react';

interface ProgressBarProps {
    steps: number;
    activeStep: number;
    setActiveStep: (step: number) => void;
  }
  
  const ProgressBar: FC<ProgressBarProps> = ({ steps, activeStep, setActiveStep }) => {
    const handleClickStep = (step: number) => {
      setActiveStep(step);
    };
    return (
      <div className="flex justify-between items-center w-full md:flex md:justify-center md:gap-[18px]">
        {Array(steps).fill(null).map((_, i) => (
          <React.Fragment key={i}>
            <span className={`h-[6px] w-[200px] md:w-[8em] rounded-full block  ${activeStep >= i ? 'bg-orange-500' : 'bg-gray-500'}`}   onClick={() => handleClickStep(i)} ></span>
            {i < steps - 1 && <span className="p-1"></span>}
          </React.Fragment>
        ))}
      </div>
    );
  };
  export default ProgressBar;
